export default __webpack_public_path__ + "static/media/ic-offline.3ef80cfd.svg";